<template>
  <div>
    <div v-if="sealInfo" class="mr-2">{{ sealInfo }}</div>
    <v-btn @click="toggleSeal" color="error" :outlined="isSealed">
      <v-icon>mdi-lock</v-icon>&nbsp;{{ sealButtonText }}
    </v-btn>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters({ period: 'tuitionFeePeriod/detailPeriod' }),
    isSealed() {
      return get(this.period, 'isSealed', false)
    },
    sealButtonText() {
      const isSealed = get(this.period, 'isSealed', false)
      return isSealed ? 'Mở kỳ' : 'Đóng kỳ'
    },
    sealInfo() {
      const sealedBy = get(this.period, 'sealedBy')
      const sealedAt = get(this.period, 'sealedAt')
      if (sealedBy && sealedAt) {
        return `Cập nhật lần cuối lúc ${moment(sealedAt).format('HH:mm DD/MM/YYYY')} bởi ${get(sealedBy, 'name')}`
      }
      return ''
    }
  },
  methods: {
    ...mapActions({ sealPeriod: 'tuitionFeePeriod/sealPeriod' }),
    toggleSeal() {
      const currentState = this.isSealed
      const periodId = this.period.id
      let title = 'Xác nhận đóng kỳ học phí',
        text = 'Bạn sẽ không thể tương tác với các hoá đơn của học sinh nữa',
        successMessage = 'Đóng kỳ học phí thành công'
      if (currentState) {
        title = 'Xác nhận mở kỳ học phí'
        text = 'Bạn sẽ tương tác được với các hoá đơn của học sinh sau khi mở'
        successMessage = 'Mở kỳ học phí thành công'
      }
      this.$dialog.confirm({
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.sealPeriod({ id: periodId, isSealed: !currentState })
            this.$alert.success(successMessage)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>